import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import DataSafety from "@/pages/DataSafety";
export const Route = createFileRoute("/data-safety")({ head: ({match}) => pageHead(match.pathname), component: () => (<DataSafety />) });
